// import { ConsoleSpanExporter, SimpleSpanProcessor, BatchSpanProcessor } from '@opentelemetry/tracing' // BatchSpanProcessor
// import { BatchSpanProcessor } from '@opentelemetry/tracing' // BatchSpanProcessor
import { SimpleSpanProcessor } from '@opentelemetry/tracing' // BatchSpanProcessor
import { WebTracerProvider } from '@opentelemetry/web'
import { DocumentLoad } from '@opentelemetry/plugin-document-load'
import { ZipkinExporter } from '@opentelemetry/exporter-zipkin'
import { ZoneContextManager } from '@opentelemetry/context-zone'
import { isDocApplication } from '@/utils/app.js'

export const tracerProvider = new WebTracerProvider({
  plugins: [
    new DocumentLoad()
  ]
})

const zipkinEndpoint = process.env.VUE_APP_ZIPKIN_URL

if (zipkinEndpoint) {
  // tracerProvider.addSpanProcessor(new SimpleSpanProcessor(new ConsoleSpanExporter()))
  // tracerProvider.addSpanProcessor(new BatchSpanProcessor(new ZipkinExporter({
  tracerProvider.addSpanProcessor(new SimpleSpanProcessor(new ZipkinExporter({
    url: zipkinEndpoint,
    serviceName: isDocApplication() ? 'Contract-Web' : 'Assistant-Web'
  })))
}

tracerProvider.register({
  contextManager: new ZoneContextManager()
})

export const defaultTracer = tracerProvider.getTracer('default')
